export default __webpack_public_path__ + "static/media/Venturer's Gauntlets of the Primeval.6fe11ff5.jpg";